import { ColorsEnum } from "../../../core/et3-theme/colors";

const ALPHA_SOFT = "1F";
const ALPHA_GOLD_SOFT = "33";

export const APPROVAL_SOFT_PENDING = `${ColorsEnum.davysGrey}${ALPHA_SOFT}`;
export const APPROVAL_SOFT_APPROVED = `${ColorsEnum.seaGreen}${ALPHA_SOFT}`;
export const APPROVAL_SOFT_REJECTED = `${ColorsEnum.red}${ALPHA_SOFT}`;
export const APPROVAL_SOFT_DELETED = `${ColorsEnum.gray}${ALPHA_SOFT}`;
export const APPROVAL_SOFT_TODO = `${ColorsEnum.darkOrange}${ALPHA_SOFT}`;
export const APPROVAL_SOFT_GOLD = `${ColorsEnum.vipGold}${ALPHA_GOLD_SOFT}`;
export const APPROVAL_GOLD_INK = "#8A6A00";
export const APPROVAL_TODO_INK = "#A96A05";

export const STRIP_PADDING_X = 16;
export const STRIP_PADDING_Y = 12;
export const STRIP_ACCENT_WIDTH = 3;
export const STRIP_ITEM_GAP = 24;
export const STRIP_ROW_GAP = 8;
export const STRIP_TOTAL_FONT_SIZE = 22;
export const STRIP_LABEL_FONT_SIZE = 11;
export const STRIP_LANE_FONT_SIZE = 13;
export const STRIP_DIVIDER_WIDTH = 1;


export const CHIP_HEIGHT = 21;
export const CHIP_PADDING = 7;
export const CHIP_FONT_SIZE = 10;
export const CHIP_RADIUS_CSS = "5px";
export const CHIP_LETTER_SPACING = 0.4;

export const ID_PILL_HEIGHT = 21;
export const ID_PILL_PADDING = 7;
export const ID_PILL_FONT_SIZE = 12;
export const ID_PILL_RADIUS_CSS = "5px";

export const EMPTY_STATE_PADDING = 48;
export const EMPTY_STATE_GLYPH_BOX = 62;
export const EMPTY_STATE_GLYPH_SIZE = 30;
export const EMPTY_STATE_GLYPH_RADIUS_CSS = "17px";
export const EMPTY_STATE_TITLE_FONT_SIZE = 18;
export const EMPTY_STATE_BODY_FONT_SIZE = 14;
export const EMPTY_STATE_GAP = 12;

export const LAST_DECISION_HEIGHT = 40;
export const LAST_DECISION_PADDING = 14;
export const LAST_DECISION_FONT_SIZE = 13;
export const LAST_DECISION_GAP = 12;
export const LAST_DECISION_RADIUS_CSS = "10px";

export const PICTURE_VIEWER_SIZE = 520;
export const PICTURE_VIEWER_WIDTH = 1500;
export const PICTURE_VIEWER_TOP = 80;
export const PICTURE_VIEWER_PADDING = 16;
export const PICTURE_VIEWER_Z_INDEX = 20;
export const PICTURE_VIEWER_CLOSE_BOX = 32;
export const PICTURE_VIEWER_CLOSE_ICON = 15;
